export const TEMP_NGO_INFO = "/v2/establishment/main-info";
export const ACCOUNT_INFO = "/v2/establishment/account";
export const NGO_INFO = "/v2/establishment/ngo";
export const NGO_SIGNUP = "/v2/establishment/create-ngo";
export const FOUNDERS = "v2/establishment/member";
export const DOCUMENTS = "v2/establishment/docs";
export const DOCUMENTS_BY_ID = (id) => `v2/establishment/docs/${id}`;
export const FOUNDER_BY_ID = (id) => `v2/establishment/member/${id}`;
export const REAL_ESTATES = "v2/establishment/create-real-estate";
export const REAL_ESTATES_BY_ID = (id) => `v2/establishment/member/${id}`;
export const TRANSACTION_REQUESTS_BY_ID = "v2/establishment/transaction-requests";
export const EDIT_TRANSACTION_REQUESTS_BY_ID = (id) => `v2/establishment/transaction-requests/${id}`;
export const LOG = `v2/establishment/member/`;
export const TRANSACTION_REQUESTS = `v2/establishment/show-transaction-request`;
export const CURRENT_STAGE = "v2/establishment/change-current-stage-number";